import Nullstack from 'nullstack';
export default function IconArrowMoveLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-move-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M13 12h-10"
  }), "   ", Nullstack.element("path", {
    d: "M6 15l-3 -3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M17 12a2 2 0 1 1 4 0a2 2 0 0 1 -4 0z"
  }), " ");
}